import { MeteoWeatherTableMock } from '../MeteoWeatherTable/MeteoWeatherTableMock/MeteoWeatherTableMock.component';
import { MeteoTabGroup } from '@components/Tab/MeteoTab/MeteoTabGroup.component';
import { SingleTab } from '@components/Tab/SingleTab.component';

function MeteoHomeForecastTabsMock() {
  return (
    <MeteoTabGroup activeId={0} isForHourByHour={false}>
      <SingleTab
        disabled
        label={window.innerWidth > 768 ? 'meteo.heure-par-heure.long-title' : 'meteo.heure-par-heure.short-title'}
      >
        <MeteoWeatherTableMock />
      </SingleTab>
      <SingleTab disabled label={window.innerWidth > 768 ? 'meteo.36hours.long-title' : 'meteo.36hours.short-title'} />
      <SingleTab disabled label={window.innerWidth > 768 ? 'meteo.15days.long-title' : 'meteo.15days.short-title'} />
    </MeteoTabGroup>
  );
}

export { MeteoHomeForecastTabsMock };
